//Add Javascript that only is used for specific domain group

// Accordion Tabs
$(document).ready(function () {
    $('.tab_wrapper > .tab_container > .tab-title').click(function () {
        console.log('click');
        $(this).parent().children('.tab-content').slideToggle();
        return false;
    });

    if ($('.stadium_image_wrapper').length) {
        //set first stadium item visible
        $('.stadiums_container .stadium_info:first-of-type').addClass('showme');

        var stadium_wrapper = $('.stadium_image_wrapper');
        stadium_wrapper.each(function () {
            $(this).slick({
                dots: true,
                arrows: false,
                infinite: true,
            });
        });
    }

    // Collapse and expand menu dropdown
    var $html = $('html'),
        $header = $('body > header'),
        $menuDropdown = $('.menu-dropdown'),
        $menuDropdownToggle = $('.menu-dropdown-toggle'),
        menuDropdownActiveClass = 'menu-dropdown-active';

    $menuDropdownToggle.click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $header.toggleClass(menuDropdownActiveClass);
        $html.toggleClass(menuDropdownActiveClass);
    });

    // Collapse and expand profile dropdown
    var $profileDropdown = $('.profile-dropdown');
    $profileDropdown.click(function (e) {
        $(e.currentTarget).toggleClass('active');
        $header.toggleClass('profile-dropdown-active');
    });

    if ($('.no-match-ticker').length) {
        $('body').removeClass('has-match-ticker');
    }

    $('body').click(function (e) {
        if (!$profileDropdown.has(e.target).length && !$profileDropdown.is(e.target)) {
            $profileDropdown.toggleClass('active', false);
        }

        if (!$menuDropdown.has(e.target).length && !$menuDropdown.is(e.target) && !$header.is(e.target)) {
            $header.toggleClass(menuDropdownActiveClass, false);
            $html.toggleClass(menuDropdownActiveClass, false);
        }
    });
});
